export const configSquareType = {
  square: 1,
  tableRow: 2,
  tableCol: 3,
  checked: 4,
  rounded: 5
};
